// ABOUTME: Mock data for TechLog → Rusada oil and fuel transformation testing.
import { TechlogTruckUnit } from '../../../../types/techLog/fuel';
import { TechLogToRusadaOilAndFuelInput } from './validation';

/**
 * Mock data for oil and fuel transformation testing.
 * Includes the path-level context fields consumed by the oil and fuel schema.
 */
export const mockData: TechLogToRusadaOilAndFuelInput = {
  techlog: {
    sectorActualFuelBurn: 500,
    fuelUplifts: [
      {
        id: 'fuel-001',
        associatedRecordId: 'sector-123',
        associatedRecordType: 'Flight',
        aircraftId: 'aircraft-789',
        aircraftValuePreUplift: 800,
        aircraftValuePostUplift: 1200,
        aircraftValueActualUplift: 400,
        aircraftPlannedUplift: 450,
        truckActualUplift: 405,
        truckUnit: TechlogTruckUnit.LITER,
        density: 0.8,
        fuelType: 'standard',
        safPercentage: 0,
        aircraftPlannedDeparture: 1250,
        priceValue: 300,
        priceCurrency: 'USD',
        paid: true,
        aircraftUnit: 'kg',
        createdAt: '2024-01-15T09:15:00Z',
        updatedAt: '2024-01-15T09:15:00Z',
      },
    ],
  },
  rusada: {
    currentOilAndFuel: {
      flightId: 98765,
      upliftUnitOfMeasureId: null,
      fuelCarriedFromLastJourney: 0,
      fuelUpliftPlanned: 0,
      fuelUpliftActual: 0,
      departureFuel: 0,
      arrivalFuel: 0,
      oilUplift: 9.5,
    },
  },
};
